import { gql } from "@apollo/client";

export const LaunchCreateLead = gql`
mutation LaunchCreateLead ($LaunchCreateLeadInput: LaunchCreateLeadInput!) {
 	LaunchCreateLead (input: $LaunchCreateLeadInput) {
        state
    }
}`